import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import styled, { mediaQuery, css, academyPageFullWidth, academyResultsBar } from '../../../utils/Styling';
import Heading from '../../../components/Layouts/Heading';
import { EditPlaylistButton, usePlaylist } from '..';
import { MY_PLAYLISTS_URL_FRAGMENT } from '../../../constants/Navigation';
import { FormattedMessage } from '../../../components/I18n';
import { BackButton } from '../../navigation';
import UIFlex from 'UIComponents/layout/UIFlex';
const Subheader = styled((_ref) => {
  let {
    children
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]);

  return /*#__PURE__*/_jsx("nav", Object.assign({}, props, {
    children: /*#__PURE__*/_jsx(UIFlex, {
      align: "center",
      justify: "between",
      children: children
    })
  }));
}).withConfig({
  displayName: "PlaylistPageHeader__Subheader",
  componentId: "sc-1drpepf-0"
})(["", " & > div{height:100%;", ";}padding-right:12px;padding-left:12px;", ""], academyResultsBar, academyPageFullWidth, mediaQuery('notMobile', css(["padding-right:12px;padding-left:24px;"])));
export const PlaylistPageHeader = ({
  playlistId
}) => {
  const {
    playlist
  } = usePlaylist(Number(playlistId));
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Heading, {
      subtitle: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlists.playlist"
      }),
      title: playlist ? playlist.name : ''
    }), /*#__PURE__*/_jsxs(Subheader, {
      children: [/*#__PURE__*/_jsx(BackButton, {
        exact: true,
        to: MY_PLAYLISTS_URL_FRAGMENT,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.playlists.myPlaylists"
        })
      }), /*#__PURE__*/_jsx(EditPlaylistButton, {
        $isHiddenFor: "notMobile",
        playlistId: playlistId
      })]
    })]
  });
};